var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCameraOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 15,
    viewBox: "0 0 18 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.28906 0.914062L3.33984 2.5H9.875C10.832 2.5 11.625 3.29297 11.625 4.25V8.98047L12.5 9.66406V9.5V6V5.53516L12.8828 5.28906L15.5078 3.53906C15.7812 3.34766 16.1094 3.34766 16.4102 3.48438C16.6836 3.64844 16.875 3.94922 16.875 4.25V11.25C16.875 11.5781 16.6836 11.8789 16.4102 12.043C16.1094 12.1797 15.7812 12.1797 15.5078 11.9883L15.125 11.7422L17.4766 13.6016C17.7773 13.8203 17.832 14.2305 17.5859 14.5039C17.3672 14.8047 16.957 14.8594 16.6836 14.6133L0.496094 1.92578C0.195312 1.70703 0.140625 1.29688 0.386719 1.02344C0.605469 0.722656 1.01562 0.667969 1.28906 0.914062ZM11.3789 12.1523C11.0508 12.6719 10.5039 13 9.875 13H2.875C1.89062 13 1.125 12.2344 1.125 11.25V4.25C1.125 4.19531 1.125 4.14062 1.125 4.08594L11.3789 12.1523Z",
    fill: "#F63135"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCameraOff);
export default __webpack_public_path__ + "static/media/camera-off.1beb193c12777d97f563d4552e68d4bc.svg";
export { ForwardRef as ReactComponent };